import ApiHelper from "@/helpsers/api.helper";
import axios from "axios";
import authHelper from "@/helpsers/auth.helper";
import router from "@/router";

class shoppingCartService {


    addProductToShoppingCart(products) {
        const productArr = products.map(el => ({id: el.id, amount: el.amount}));
        const data = {
            products: productArr,
            projectId: router.currentRoute.value.params.id
        };
        return axios.post(ApiHelper.getAddProductToShoppingCartUrl(),data, {
            headers: authHelper.authHeader(),
        })
            .then(response => Promise.resolve(response))
            .catch(error => Promise.reject(error));
    }

    getAllShoppingCart(projectId) {
        return axios.get(ApiHelper.getAllShoppingCart(projectId),{
            headers: authHelper.authHeader(),
        })
            .then(response => Promise.resolve(response))
            .catch(error => Promise.reject(error));
    }

    changeProductAmount(product,basketId) {
        const data = {
            products: [
                {
                    id: product.id,
                    amount: product.amount,
                }
            ]
        }
        return axios.put(ApiHelper.getChangeAmountProductInShoppingCartUrl(basketId),data, {
            headers: authHelper.authHeader(),
        })
            .then(response => Promise.resolve(response))
            .catch(error => Promise.reject(error));
    }

    getProjectName() {
        const projectId = router.currentRoute.value.params.id;
        return axios.get(ApiHelper.getProjectDetailsUrl(projectId),{
            headers: authHelper.authHeader(),
        })
            .then(result => Promise.resolve(result.data.name))
            .catch(error => Promise.reject(error));
    }

    paymentForShoppingCart(basketId) {
        return axios.get(ApiHelper.getPaymentForShoppingCartUrl(basketId), {
            headers: authHelper.authHeader(),
        })
            .then(response => Promise.resolve(response))
            .catch(error => Promise.reject(error));
    }

}

export default shoppingCartService;